import AddressSectionForm from '../AddressSectionForm'

const AddressSection = ({ address, type, required = true }) => {
    const forceShowForm = !(address.address1 && address.address2) && required
    const { address1, address2, postalCode, city, country, firstName, lastName } = address
    const addressee = firstName && lastName && `${firstName} ${lastName}`

    const buttonCaption = (
        <div>
            {addressee && <div>{addressee}</div>}
            <span>
                {address1}, {address2 ? `${address2},` : ''} {postalCode}, {city}, {country}
            </span>
        </div>
    )

    return (
        <div className="mt-6">
            <h3 className="mb-5 font-weight-bold">
                <T>{`subscription.purchase.label.${type}`}</T>
            </h3>
            <AddressSectionForm
                address={address}
                type={type}
                forceShowForm={forceShowForm}
                buttonCaption={buttonCaption}
            />
        </div>
    )
}
export default AddressSection
